// extracted by mini-css-extract-plugin
module.exports = {"container":"missingDeck_container__dY_ge","branding":"missingDeck_branding__QcEBA"};